






import {Vue, Component } from "vue-property-decorator";

@Component({name: "SettingsButton"})
export default class SettingsButton extends Vue {}
